// extracted by mini-css-extract-plugin
export default {"topics":"UJFKlq85MVVih57RjXMs","topic":"T5U_9gfOBcqA_NF9INCw"};